import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import betHistory from 'views/cash/bets/betHistory'; // Importing betHistory view
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the reprint check view.
 * @extends JetView
 */
export default class reprintCheckView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The layout configuration object.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        const left = {
            Width: 250, // Width of the left column
            responsiveCell: false, // Disable responsive behavior for this cell
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Apply the current theme
                    elements: [
                        {
                            view: 'label', // Label component
                            label: _('Apuestas Deportivas'), // Translated label text
                            width: 300, // Width of the label
                        },
                    ],
                },
                betHistory, // Include the betHistory view
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            type: 'wide', // Layout type
            responsive: true, // Enable responsive layout
            css: 'out', // CSS class for styling
            cols: [left, { view: 'resizer' }], // Define columns with a resizer
        };
    }
}

// FILE DOCUMENTED
